import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useWaitlist } from "@/context/waitlist";

const LINKS = [
  { to: "/science", label: "SCIENCE" },
  { to: "/programmes", label: "PROGRAMMES" },
  { to: "/products", label: "PRODUCTS" },
  { to: "/technology", label: "TECHNOLOGY" },
  { to: "/thinking", label: "THINKING" },
  { to: "/about", label: "ABOUT" },
  { to: "/contact", label: "CONTACT" },
];

const linkClass = ({ isActive }) =>
  `font-mono text-[10px] tracking-[0.25em] transition-colors ${
    isActive ? "text-[#C9A227]" : "text-[#8e8a80] hover:text-[#f5f2ea]"
  }`;

export default function Nav() {
  const openWaitlist = useWaitlist();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-[#1f1e1a] bg-[#0a0a09]/90 backdrop-blur-md">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4"
        aria-label="Main navigation"
      >
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display text-sm font-extrabold tracking-[0.3em] text-[#f5f2ea]"
        >
          W8ED
        </Link>

        <div className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </NavLink>
          ))}
          <button
            type="button"
            data-testid="nav-join-w8list"
            onClick={openWaitlist}
            className="border border-[#3a3524] px-4 py-2 font-mono text-[10px] tracking-[0.25em] text-[#C9A227] transition-colors hover:border-[#C9A227]"
          >
            JOIN THE W8LIST
          </button>
        </div>

        <button
          type="button"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          data-testid="nav-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          className="p-2 text-[#8e8a80] transition-colors hover:text-[#f5f2ea] lg:hidden"
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {menuOpen && (
        <div className="border-t border-[#1f1e1a] bg-[#0a0a09] px-6 py-8 lg:hidden">
          <div className="flex flex-col gap-6">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setMenuOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-display text-2xl font-bold tracking-wide ${
                    isActive ? "text-[#C9A227]" : "text-[#f5f2ea]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              type="button"
              data-testid="nav-mobile-join-w8list"
              onClick={() => {
                setMenuOpen(false);
                openWaitlist();
              }}
              className="mt-4 border border-[#3a3524] px-5 py-3 text-left font-mono text-[11px] tracking-[0.25em] text-[#C9A227]"
            >
              JOIN THE W8LIST
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
